import React, { useEffect, useState } from "react";
import AddStaff from "./component/AddStaff/AddStaff";
import "./Staff.scss";
import StaffList from "./component/StaffList/StaffList";
import { ActivateUser, DeactivateUser, getSignupReDetail } from "../../apiCall";
import toast from "react-hot-toast";
import UpdateStaff from "./component/UpdateStaff/UpdateStaff";
import { ConfirmationModal } from "../../components/Modals/ConfirmationModal";
const Staff = () => {
  const [activeTab, setActiveTab] = useState("staffList");
  const [editUserData, setEditUserData] = useState({});
  const [userTypeOption, setUserTypeOption] = useState([]);
  const [genderOption, setGenderOption] = useState([]);
  const [newAddedStaff, setNewAddedStaff] = useState({});
  const [newUpdatedStaff, setNewUpdatedStaff] = useState({});
  const [attachmentCount, setAttachmentCount] = useState(0);
  const [isStaffDetailRefetch, setIsStaffDetailRefetch] = useState(false);
  const staffDetailRefetch = ()=>{
    setIsStaffDetailRefetch(true)
  }

  const transformedArray = (inputArray) => {
    const output = inputArray.map((obj) => {
      const key = Object.keys(obj)[0];
      const value = obj[key];
      return { id: key, value: value };
    });
    return output;
  };

  // ************************************************************* Confirmation modal start **********************************

  const [confirmationShow, setConfirmationShow] = useState(false);
  const [funHandler, setFunHandler] = useState();
  const handleConfirmationClose = () => {
    setConfirmationShow(false);
  };
  const handleConfirmationShow = () => setConfirmationShow(true);
  useEffect(() => {
    const fetchData = async () => {
      const re = await getSignupReDetail();
      if (re?.status === 200) {
        setGenderOption(transformedArray(re.data.gender));
        setUserTypeOption(transformedArray(re.data.types));
      } else if(re?.response)  {
        toast.error("can't fetch data of user type and gender.");
      }
    };
    fetchData();
  }, []);
  // ************************************************************* Confirmation modal end **********************************

  switch (activeTab) {
    case "staffList":
      return (
        <>
          <StaffList
            setActiveTab={setActiveTab}
            setEditUserData={setEditUserData}
            userTypeOption={userTypeOption}
            handleConfirmationShow={handleConfirmationShow}
            setFunHandler={setFunHandler}
            newAddedStaff={newAddedStaff}
            newUpdatedStaff={newUpdatedStaff}
            setNewAddedStaff={setNewAddedStaff}
            setNewUpdatedStaff={setNewUpdatedStaff}
            setAttachmentCount={setAttachmentCount}
            attachmentCount={attachmentCount}
            setIsStaffDetailRefetch={setIsStaffDetailRefetch}
            isStaffDetailRefetch={isStaffDetailRefetch}
          />
          <ConfirmationModal
            show={confirmationShow}
            onHide={handleConfirmationClose}
            funHandler={funHandler}
          />
          ;
        </>
      );

    case "addStaff":
      return (
        <AddStaff
          userTypeOption={userTypeOption}
          genderOption={genderOption}
          setActiveTab={setActiveTab}
          editUserData={editUserData}
          setEditUserData={setEditUserData}
          setAttachmentCount={setAttachmentCount}
          attachmentCount={attachmentCount}
          setNewAddedStaff={setNewAddedStaff}
        />
      );
    case "updateStaff":
      return (
        <>
          <UpdateStaff
            userTypeOption={userTypeOption}
            genderOption={genderOption}
            setActiveTab={setActiveTab}
            editUserData={editUserData}
            handleConfirmationShow={handleConfirmationShow}
            setFunHandler={setFunHandler}
            setNewUpdatedStaff={setNewUpdatedStaff}
            setAttachmentCount={setAttachmentCount}
            attachmentCount={attachmentCount}
            detailRefetch={staffDetailRefetch}

          />
          <ConfirmationModal
            show={confirmationShow}
            onHide={handleConfirmationClose}
            funHandler={funHandler}
          />
          ;
        </>
      );

    default:
      return "";
  }
};

export default Staff;
